import React from "react";

const SellerOrders = () => {
  const orders = [
    { id: "ORD1234", date: "29 Jun 2024", amount: "₹1,500", status: "Delivered" },
    { id: "ORD5678", date: "28 Jun 2024", amount: "₹1,200", status: "Pending" },
  ];

  return (
    <div>
      <h1 className="text-2xl font-bold mb-4">Orders</h1>

      <div className="bg-white rounded-xl shadow p-4">
        <table className="w-full text-left">
          <thead>
            <tr className="border-b">
              <th className="py-2">Order ID</th>
              <th className="py-2">Date</th>
              <th className="py-2">Amount</th>
              <th className="py-2">Status</th>
            </tr>
          </thead>

          <tbody>
            {orders.map((o) => (
              <tr key={o.id} className="border-b">
                <td className="py-2">{o.id}</td>
                <td className="py-2">{o.date}</td>
                <td className="py-2">{o.amount}</td>
                <td
                  className={`py-2 font-semibold ${
                    o.status === "Delivered" ? "text-green-600" : "text-orange-600"
                  }`}
                >
                  {o.status}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SellerOrders;
